import { render, staticRenderFns } from "./breadcumb.vue?vue&type=template&id=6abcdf4a&"
import script from "./breadcumb.vue?vue&type=script&lang=js&"
export * from "./breadcumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports